// @ts-nocheck
import { DashboardLayout } from "./Dashboard";
import TableWithSearch from "@/components/TableWithSearch";
import { ColumnHeader } from "@/components/MyTable";
import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router";
import { useOrg } from "@/contexts/useOrg";
import { useAuth } from "@/contexts/use-auth";
import { formatDateTime12, formatDateTime24 } from "@/utils/helpers";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { toast } from "sonner";
import AxiosInstance from "@/utils/AxiosInstance";
import {
  Plus,
  RefreshCw,
  User,
  Smartphone,
  Package,
  Building,
  Eye,
  ExternalLink,
} from "lucide-react";
import RHFWrapper from "@/components/RHFWrapper";
import RhfRadio from "@/components/rhfFields/RhfRadio";
import RhfSelect from "@/components/rhfFields/RhfSelect";
import RhfInput from "@/components/rhfFields/RhfInput";
import * as yup from "yup";
import RhfAsyncSelect from "@/components/rhfFields/RhfAsyncSelect";
import MyDialogContent from "@/components/MyDialogContent";

const ticketTypeOptions = [
  { value: "addressConfirmation", label: "Address confirmation" },
  { value: "engagement", label: "Engagement" },
  { value: "clinicalSupport", label: "Clinical support" },
  { value: "other", label: "Other" },
  { value: "returnToSender", label: "Return to sender" },
  { value: "returnMerchandiseAuthorization", label: "Return merchandise authorization" },
  { value: "deviceTechnicalSupport", label: "Device technical support" },
  { value: "customerDeviceInquiry", label: "Customer device inquiry" },
  { value: "operations", label: "Operations" },
  { value: "patientSetup", label: "Patient setup" },
  { value: "mobileSupport", label: "Mobile support" },
  { value: "labOrder", label: "Lab order" },
  { value: "alert", label: "Alert" },
  { value: "patientJourney", label: "Patient journey" },
  { value: "generalInquiry", label: "General inquiry" },
  { value: "deviceClaim", label: "Device claim" },
  { value: "technicalSupport", label: "Technical support" },
  { value: "patientEnrollment", label: "Patient enrollment" },
  { value: "patientEngagement", label: "Patient engagement" },
  { value: "accountManagement", label: "Account management" },
  { value: "trackingOrderInquiry", label: "Tracking / order inquiry" },
  { value: "returnReplacementInquiry", label: "Return / replacement inquiry" },
  { value: "procurementSupplyInquiry", label: "Procurement / supply inquiry" },
  { value: "inventoryCheckCountRequest", label: "Inventory check / count request" },
  { value: "platformLoginRequest", label: "Platform login request" },
  { value: "shipmentAddressChangeRequest", label: "Shipment address change request" },
  { value: "apiDatafeedRequest", label: "API / datafeed request" },
  { value: "kitChangeRequest", label: "Kit change request" },
  { value: "howToPlaceOrder", label: "How to place order" },
  { value: "howToReplaceReturnDevice", label: "How to replace / return device" },
  { value: "reportingRequest", label: "Reporting request" },
  { value: "autoAgent", label: "Auto agent" },
] as const;

const ticketHeaders: ColumnHeader[] = [
  { id: "ticketId", label: "Ticket ID", isSortable: false },
  // { id: "patientName", label: "Patient", isSortable: true },
  { id: "ticketType", label: "Ticket Type", isSortable: true },
  { id: "patientName", label: "Patient Name", isSortable: false },
  // { id: "currentStatus", label: "Status", isSortable: true },
  { id: "siteName", label: "Site", isSortable: false },
  { id: "assigneeName", label: "Assignee", isSortable: false },
  { id: "createdByName", label: "Created By", isSortable: false },
  { id: "createdAt", label: "Created At", isSortable: true },
  { id: "status", label: "Status", isSortable: false },
  { id: "lastUpdatedImpilo", label: "Last Updated", isSortable: true },
];

const statusColors: Record<string, string> = {
  needsintake: "text-orange-600 bg-orange-50",
  open: "text-blue-600 bg-blue-50",
  inprogress: "text-yellow-600 bg-yellow-50",
  resolved: "text-green-600 bg-green-50",
  closed: "text-gray-600 bg-gray-50",
};

export default function Support({ patientId }: { patientId?: string }) {
  const { selectedOrgId, isAllSelected } = useOrg();
  const { user , profile  } = useAuth();
  const navigate = useNavigate();
  const isCaretaker = user?.role === "caretaker";


  const [data, setData] = useState<any[]>([]);
  const [filters, setFilters] = useState<any>({});
  const [refreshKey, setRefreshKey] = useState(0);
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
  const [isViewDialogOpen, setIsViewDialogOpen] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState<any>(null);
  const [btnLoading, setBtnLoading] = useState(false);
  const [syncLoading, setSyncLoading] = useState(false);

  const subjectCategories = [
    { key: "patient", label: "Patient", icon: User },
    // { key: "device", label: "Device", icon: Smartphone },
    // { key: "order", label: "Order", icon: Package },
    // { key: "site", label: "Site", icon: Building },
  ];

  const handleCreateTicket = async (formData: any, methods: any) => {
    setBtnLoading(true);
    try {
      const payload: any = {
        patientId: patientId || formData?.patientId?.value || formData?.patientId || "",
        subject: formData?.subject || "",
        ticketType: formData?.ticketType || "",
        // priority: formData?.priority || "",
        note: formData?.note || "",
      };

      // // Optional fields (only send if present)
      // if (formData?.deviceId) payload.deviceId = formData.deviceId;
      // if (formData?.orderId) payload.orderId = formData.orderId;
      // if (formData?.siteId) payload.siteId = formData.siteId;

      const { data } = await AxiosInstance().post("/impilo/support-tickets/create", payload);
      console.log({data});
      toast.success(data?.message || "Support ticket created successfully.");
      setIsCreateDialogOpen(false);
      methods?.reset?.();
      setRefreshKey((prev) => prev + 1);
    } catch (e: any) {
      const msg =
        e?.response?.data?.message ||
        e?.message ||
        "Failed to create ticket";
      toast.error(msg);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleSyncTickets = async () => {
    try {
      setSyncLoading(true);
      await AxiosInstance().get("/impilo/support-tickets/sync");
      toast.success("Support tickets synced successfully.");
      setRefreshKey((prev) => prev + 1);
    } catch (e: any) {
      const msg =
        e?.response?.data?.message ||
        e?.message ||
        "Failed to sync support tickets";
      toast.error(msg);
    } finally {
      setSyncLoading(false);
    }
  };

  const handleViewTicket = (row: any) => {
    // console.log({row});
    // const original = data.find((t) => t.id === row.id);
    setSelectedTicket(row);
    setIsViewDialogOpen(true);
  };

  const formatTicketType = (type: string) => {
    if (!type) return "";
    return type.replace(/([A-Z])/g, " $1").replace(/^./, (s) => s.toUpperCase()).trim();
  };

  const renderBadge = (value: string, colorMap: Record<string, string>) => {
    const label = (value || "").replace(/([A-Z])/g, " $1").replace(/^./, (s) => s.toUpperCase()).trim();
    const cls = colorMap[value?.toLowerCase()] || "text-gray-600 bg-gray-50";
    return (
      <span
        className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium capitalize ${cls}`}
      >
        {label}
      </span>
    );
  };

  // const filtersOptions = [
  //   {
  //     key: "currentStatus",
  //     label: "Status",
  //     type: "select",
  //     options: [
  //       { label: "Needs Intake", value: "needsIntake" },
  //       { label: "Open", value: "open" },
  //       { label: "In Progress", value: "inProgress" },
  //       { label: "Resolved", value: "resolved" },
  //       { label: "Closed", value: "closed" },
  //     ],
  //   },
  // ];

  const Wrapper = useMemo(() => patientId
    ? React.Fragment
    : ({ children }: { children: React.ReactNode }) => (
        <DashboardLayout activePage="/support">{children}</DashboardLayout>
      ), [patientId]);

  const ticketsTable = (
      <TableWithSearch
        heading="Support Tickets"
        url="/impilo/support-tickets"
        params={{
          refreshKey,
          ...(patientId && patientId !== "undefined"
            ? { patientId: patientId }
            : {}),
        }}
        apiDataKey="content"
        fetchCondition={true}
        isIncludeSearch={false}
        searchPlaceholder="Search tickets by type or ID"
        columnHeaders={ticketHeaders}
        data={data}
        viewData={data.map((ticket: any) => ({
          ...ticket,
          ticketType: formatTicketType(ticket?.ticketType),
          // patientName: ticket?.raw?.patient ? `${ticket?.raw?.patient?.firstName || ""} ${ticket?.raw?.patient?.middleName || ""} ${ticket?.raw?.patient?.lastName || ""}`.trim() : "—",
          // currentStatus: renderBadge(ticket?.currentStatus, statusColors),
          patientName: ticket?.raw?.patient ? `${ticket?.raw?.patient?.firstName || ""} ${ticket?.raw?.patient?.middleName || ""} ${ticket?.raw?.patient?.lastName || ""}`.trim() : "—",
          siteName: ticket?.site?.name || "—",
          assigneeName: ticket?.assignee
            ? `${ticket.assignee.firstName} ${ticket.assignee.lastName}`
            : "—",
          createdByName: ticket?.createdByUser
            ? `${ticket.createdByUser?.name || ""}`
            : "—",
          createdAt: ticket?.createdAtImpilo
            ? formatDateTime12(ticket.createdAtImpilo)
            : "",
          lastUpdatedImpilo: ticket?.lastUpdatedImpilo
            ? formatDateTime12(ticket.lastUpdatedImpilo)
            : "",
          status:  ticket?.open ? "Open" : "Closed",
        }))}
        setData={setData}
        isActionColumn={false}
        // filtersOptions={filtersOptions}
        handleAction={() => {}}
        filters={filters}
        setFilters={setFilters}
        // clickRow={handleRowClick}
        isIgnoreSearchParams={true}
        donotFetch={false}
        headerExtraControls={
          !isCaretaker ? (
            <Button
              onClick={() => setIsCreateDialogOpen(true)}
              variant="outline"
              className="rounded-full"
            >
              <Plus className={`w-4 h-4 mr-1`} /> New Ticket
            </Button>
          ) : null
        }
        moreActions={[
          {
            label : "View Ticket",
            icon: <Eye/>,
            isShow:()=> true,
            onClick: (data)=> handleViewTicket(data)
          },
          {
            label: "Open Ticket Page",
            icon: <ExternalLink />,
            isShow: () => true,
            onClick: (data) => {
              const ticketId = data?._id || data?.ticketId || "";
              navigate(`/support/${ticketId}`);
            },
          },
        ]}
      />
  );

  return (
    <Wrapper>
      {ticketsTable}

      {/* Create Ticket Dialog */}
      <Dialog open={isCreateDialogOpen} onOpenChange={setIsCreateDialogOpen} className="p-0">
        <MyDialogContent heading="Create Support Ticket">
        {/* <DialogContent className="max-w-full w-full md:max-w-6xl p-0 gap-0"> */}
          {/* <DialogHeader className="px-6 pt-6 pb-4">
            <DialogTitle className="text-xl">Create Support Ticket</DialogTitle>
          </DialogHeader> */}

          <RHFWrapper
            initialValues={{
              subject: "",
              patientId: null,
              ticketType: "",
              // priority: "",
              note: "",
            }}
            isValidate={true}
            validateSchema={yup.object({
              subject: yup.string().required("Subject is required"),
              ticketType: yup.string().required("Ticket type is required"),
              // priority: yup.string().required("Priority is required"),
              note: yup.string().required("Note is required"),
              patientId : yup.mixed().required("Patient is required"),
            })}
            onSubmit={handleCreateTicket}
          >
          <div className="">
            {/* Subject Section */}
            {/* <div className="grid grid-cols-1 md:grid-cols-[200px_1fr] gap-4 px-6 py-5">
              <div>
                <h3 className="font-semibold text-sm">Subject</h3>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                {subjectCategories.map((cat) => {
                  const Icon = cat.icon;
                  const isSelected = newTicket.subject === cat.key;
                  return (
                    <button
                      key={cat.key}
                      type="button"
                      onClick={() =>
                        setNewTicket((prev) => ({ ...prev, subject: cat.key }))
                      }
                      className={`flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg border text-sm font-medium transition-all ${
                        isSelected
                          ? "border-primary bg-primary/10 text-primary"
                          : "border-gray-200 bg-white hover:border-gray-300 hover:bg-gray-50 text-gray-700"
                      }`}
                    >
                      <Icon className="w-4 h-4" />
                      {cat.label}
                    </button>
                  );
                })}
              </div>
            </div> */}

<RhfRadio
        name="subject"
        label="Subject"
        required
        className="px-2 py-2"
        options={[
          { label: "Patient", value: "patient" },
          // { label: "Device", value: "device" },
        ]}
      />

<div className="px-2 py-2 ">
<RhfAsyncSelect
            label="Patient"
            name="patientId"
            portalToBody={false}
            storeOptionObject={true}
            isAsync
            asyncConfig={{
              apiUrl: "/patients",
              searchParam:"search",
              minSearchLength: 3,
              responseMapper: (response) =>
                response?.data?.patients?.map((patient: any) => ({
                  label: `${patient?.patientId || ""} - ${patient?.firstName || ""} ${patient?.middleName || ""} ${patient?.lastName || ""}`.trim(),
                  value: patient?._id,
                })) ?? [],
            }}
            placeholder="Search patient by name, ID, email, number..."
            required
          />
</div>
            {/* Ticket Type, Assignee, and Priority Section */}
            <div className="px-2 py-2 flex flex-col gap-4">
              
              <div className="flex flex-row gap-4">
                  {/* <div className="space-y-1.5">
                    <Label className="text-sm text-muted-foreground">
                      Ticket Type
                    </Label>
                    <Select
                      value={newTicket.ticketType}
                      onValueChange={(value) =>
                        setNewTicket((prev) => ({ ...prev, ticketType: value }))
                      }
                    >
                      <SelectTrigger>
                        <SelectValue placeholder="Select type" />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="bug">Bug</SelectItem>
                        <SelectItem value="feature_request">
                          Feature Request
                        </SelectItem>
                        <SelectItem value="question">Question</SelectItem>
                        <SelectItem value="access_issue">
                          Access Issue
                        </SelectItem>
                        <SelectItem value="other">Other</SelectItem>
                      </SelectContent>
                    </Select>
                  </div> */}
                  <RhfSelect
                    name="ticketType"
                    label="Ticket Type"
                    required
                    className="px-2 py-2"
                    options={ticketTypeOptions}
                  />
                  {/* <RhfSelect
                    name="priority"
                    label="Priority"
                    required
                    className="px-6 py-5"
                    options={[
                      { label: "Low", value: "low" },
                      { label: "Medium", value: "medium" },
                      { label: "Urgent", value: "urgent" },
                      { label: "Not Specified", value: "not_specified" },
                    ]}
                  /> */}
                  {/* <div className="space-y-1.5">
                    <Label className="text-sm text-muted-foreground">
                      Assignee
                    </Label>
                    <Input
                      placeholder="Search for user..."
                      value={newTicket.assignee}
                      onChange={(e) =>
                        setNewTicket((prev) => ({
                          ...prev,
                          assignee: e.target.value,
                        }))
                      }
                    />
                  </div> */}
                {/* <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div className="space-y-1.5">
                    <Label className="text-sm text-muted-foreground">
                      Priority
                    </Label>
                    <Select
                      value={newTicket.priority}
                      onValueChange={(value) =>
                        setNewTicket((prev) => ({ ...prev, priority: value }))
                      }
                    >
                      <SelectTrigger>
                        <SelectValue placeholder="Select priority" />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="low">Low</SelectItem>
                        <SelectItem value="medium">Medium</SelectItem>
                        <SelectItem value="high">High</SelectItem>
                        <SelectItem value="critical">Critical</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                </div> */}
              </div>
            </div>

            {/* Note Section */}
            <div className="px-2 py-2 flex flex-col gap-4">
              <RhfInput
                name="note"
                label="Note"
                required
                type="textarea"
                rows={5}
                placeholder="Describe the issue or add any relevant details..."
                className="px-2 py-2"
              />
            </div>

            {/* Submit */}
            <div className="flex justify-end px-2 py-2 pb-0 sticky bottom-0 w-full bg-white">
              <Button
                type="submit"
                loading={btnLoading}
                disabled={btnLoading}
                className="px-8"
              >
                {btnLoading ? "Creating..." : "Create Ticket"}
              </Button>
            </div>
          </div>
          </RHFWrapper>
        {/* </DialogContent> */}
        </MyDialogContent>
      </Dialog>

      {/* View Ticket Dialog */}
      <Dialog open={isViewDialogOpen} onOpenChange={setIsViewDialogOpen}>
        <MyDialogContent heading="Ticket Details">
        {/* <DialogContent className="w-full sm:max-w-4xl max-h-[85vh] overflow-y-auto"> */}
          {/* <DialogHeader>
            <DialogTitle>Ticket Details</DialogTitle>
          </DialogHeader> */}
          {selectedTicket && (
            <div className="space-y-4 mt-2">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label className="text-muted-foreground text-xs">
                    Ticket ID
                  </Label>
                  <p className="font-medium">{selectedTicket?.ticketId}</p>
                </div>
                {/* <div>
                  <Label className="text-muted-foreground text-xs">
                    Status
                  </Label>
                  <div className="mt-1">
                    {renderBadge(selectedTicket?.raw?.currentStatus, statusColors)}
                  </div>
                </div> */}
                <div>
                  <Label className="text-muted-foreground text-xs">
                    Ticket Type
                  </Label>
                  <p className="font-medium">
                    {formatTicketType(selectedTicket.ticketType)}
                  </p>
                </div>
                {/* <div>
                  <Label className="text-muted-foreground text-xs">
                    Open
                  </Label>
                  <p className="font-medium">
                    {selectedTicket.open ? "Yes" : "No"}
                  </p>
                </div> */}
                <div>
                  <Label className="text-muted-foreground text-xs">
                    Customer
                  </Label>
                  <p className="font-medium">
                    {selectedTicket.customer?.name || "—"}
                  </p>
                </div>
                <div>
                  <Label className="text-muted-foreground text-xs">
                    Site
                  </Label>
                  <p className="font-medium">
                    {selectedTicket?.raw?.site?.name || "—"}
                  </p>
                </div>
                {/* <div>
                  <Label className="text-muted-foreground text-xs">
                    Assignee
                  </Label>
                  <p className="font-medium">
                    {selectedTicket.assignee
                      ? `${selectedTicket.assignee.firstName} ${selectedTicket.assignee.lastName}`
                      : "—"}
                  </p>
                </div> */}
                <div>
                  <Label className="text-muted-foreground text-xs">
                    Created By
                  </Label>
                  <p className="font-medium">
                    {selectedTicket.createdByUser
                      ? `${selectedTicket.createdByUser?.name || ""}`
                      : "—"}
                  </p>
                </div>
                <div>
                  <Label className="text-muted-foreground text-xs">
                    Created At
                  </Label>
                  <p className="font-medium">
                    {selectedTicket.createdAtImpilo
                      ? formatDateTime12(selectedTicket.createdAtImpilo)
                      : "—"}
                  </p>
                </div>
                {/* <div>
                  <Label className="text-muted-foreground text-xs">
                    Last Updated
                  </Label>
                  <p className="font-medium">
                    {selectedTicket.lastUpdated
                      ? formatDateTime12(selectedTicket.lastUpdated)
                      : "—"}
                  </p>
                </div> */}
              </div>
              {selectedTicket?.supportTicketNotes?.length > 0 && (
                <div>
                  <Label className="text-muted-foreground text-xs">Notes</Label>
                  <div className="space-y-2 mt-1">
                    {selectedTicket?.supportTicketNotes?.reverse()?.map(
                      (note: any, idx: number) => (
                        <div
                          key={idx}
                          className="text-sm p-3 bg-muted/50 rounded-md"
                        >
                          <p className="whitespace-pre-wrap">{note?.note}</p>
                          <p className="text-xs text-muted-foreground mt-1">
                             {note?.createdByUser?.name || ""} 
                              {note?.createdByUser?.name && `-`}
                             {formatDateTime12(note?.createdAt)}
                          </p>
                        </div>
                      )
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
        {/* </DialogContent> */}
        </MyDialogContent>
      </Dialog>
    </Wrapper>
  );
}
